export const getPostcodeAreaDistrict = (postcode) => {
  // const regex = /^([a-zA-Z]{1,2}[0-9][0-9a-zA-Z]?)\\s?[0-9][a-zA-Z]{2}?/;
  const regex = /^([a-zA-Z]{1,2}[0-9][0-9a-zA-Z]?)\s?[0-9][a-zA-Z]{2}?/;
  const match = regex.exec(postcode);
  if (match == null) {
    throw new Error("Invalid postcode");
  }
  return match[1];
};
